import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import VerifyEmailGate from "@/pages/VerifyEmailGate";
import ApprovalGate from "@/components/ApprovalGate";
import { approvalGateStatus } from "@/lib/approval";

export default function ProtectedRoute({ children }) {
  const { user, approval, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-dvh flex items-center justify-center" data-testid="auth-loading">
        <div className="inline-block h-10 w-10 border-2 border-primary border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/" replace />;
  // Blocca la dashboard finché l'email non è verificata. Controllo
  // solo su `=== false` esplicito (mai su un valore mancante/undefined): un
  // account pre-esistente o il super admin devono continuare a funzionare
  // senza essere bloccati da un campo che per loro non è mai stato impostato.
  if (user.role !== "super_admin" && user.email_verified === false) {
    return <VerifyEmailGate />;
  }
  // Approvazione manuale del Super Admin (backend/approval.py): un'attività in attesa, rifiutata o
  // sospesa vede solo la pagina di stato (con logout), PRIMA della dashboard che userebbe API
  // bloccate. Il backend resta l'unica autorità; solo uno stato esplicito blocca, mai un valore mancante.
  const gate = approvalGateStatus(user, approval);
  if (gate) return <ApprovalGate status={gate} />;
  // Nessuna configurazione iniziale obbligatoria: sedi, orari, servizi,
  // operatori e postazioni si configurano dalle sezioni della dashboard.
  return children;
}
